<template>
  <section
    :class="[
      'features',
      { 'features--justify-center': windowWidth >= justifyCenterDependWidth },
    ]"
  >
    <router-link
      :to="{ name: 'feature', params: { featureId: feature.id } }"
      v-for="(feature, index) in features"
      :key="index"
      :class="[
        'features__cards',
        { 'features__cards--more-than-5': features.length > 5 },
      ]"
      :title="`[前往]${feature.title}分類`"
    >
      <div class="features__card-with-words">
        <div class="features__card-with-words__photo">
          <img :src="feature.cover_image_url" :alt="''" />
        </div>
        <h2
          v-text="feature.title"
          :class="[
            'features__card-with-words__title',
            { active: getIsActiveFeature(feature.id) },
          ]"
        />
      </div>
    </router-link>
  </section>
</template>

<script>
export default {
  name: 'HomepageFeatures',
  props: {
    features: {
      type: Array,
      default: () => [],
    },
    featureId: {
      type: [String, Number],
      default: '',
    },
  },
  data() {
    return {};
  },
  computed: {
    windowWidth() {
      return this.$store.getters.windowWidth;
    },
    justifyCenterDependWidth() {
      // 桌機時
      // 數量五個以下，置中
      // 數量以上，置左
      const isMoreThan5 = this.features.length > 5;
      const CARD_WIDTH_OF_FEATURE = isMoreThan5 ? 200 : 288;

      return (
        CARD_WIDTH_OF_FEATURE * this.features.length +
        10 * (this.features.length - 1)
      );
    },
  },
  methods: {
    getIsActiveFeature(selectedFeatureId) {
      if (!this.featureId || !selectedFeatureId) return false;

      return selectedFeatureId.toString() === this.featureId.toString()
        ? true
        : false;
    },
  },
  components: {},
};
</script>

<style lang="scss" scoped>
.features {
  position: relative;
  display: flex;
  justify-content: flex-start;
  flex-flow: row nowrap;
  align-items: flex-start;
  width: 100%;
  max-width: 1080px;
  overflow-x: auto;
  overflow-y: hidden;
  margin-top: 0;
  padding: 0 20px;
  margin-bottom: -2px;

  @extend %ie-scrollbar;

  @include for-tablet {
    padding: 0 25px;
    width: 100%;
    max-width: 100%;
    margin-bottom: 18px;
  }

  @include for-tablet-horizontal {
    justify-content: center;

    @include article-content-spacing(desktop);
  }

  &::-webkit-scrollbar {
    width: 5px;
    height: 5px;
    border-radius: 5px;
    background-color: transparent;
  }

  &::-webkit-scrollbar-thumb {
    border-radius: 5px;
    background-color: transparent;
  }

  &--justify-center {
    @include for-tablet {
      justify-content: center;
    }
  }

  &__cards {
    flex: 0 0 auto;
    position: relative; // 讓文字對齊用

    &--more-than-5 {
      @include for-tablet {
        width: 200px;
      }

      .features__card-with-words {
        img {
          @include for-tablet {
            height: 288px;
          }
        }
      }
    }
  }

  &__cards + &__cards {
    margin-left: 20px;
  }

  &__card-with-words {
    &__photo {
      > img {
        border-radius: 50%;
        width: 180px;
        height: 180px;
        object-fit: cover;
        object-position: top;
      }
    }

    &__title {
      position: absolute;
      top: 0;
      left: 0;
      text-align: center;
      margin: 0;
      font-size: 1.125rem;
      font-weight: 400;
      line-height: 180px;
      width: 100%;
      color: $color-light-button-text;
      font-family: $title-font-family;
      font-weight: 600;
      font-size: 1.75rem;
      z-index: 1;

      &::after {
        position: absolute;
        border-radius: 50%;
        content: '';
        left: 0;
        top: 0;
        width: 100%;
        height: 100%;
        z-index: -1;
        background-color: rgba(0, 0, 0, 0.3);
      }

      &:hover {
        &::after {
          background-color: rgba(166, 107, 37, 0.9);
        }
      }

      &.active {
        &::after {
          background-color: rgba(166, 107, 37, 0.9);
        }
      }
    }
  }
}
</style>
